<template>
    <div class="master-section row justify-content-center px-0 px-md-1 mb-40px double-column-layout mb-md-60px">
        <div v-for="(item, id_item) in double" :key="id_item" class="col-12 col-md-6 mb-md-0px mb-25px">
            <a :href="item.button_link.url" v-if="item.link_type == 'section'">
                <img class="img-fluid mb-25px d-none d-md-block" :src="item.media.image_full" :alt="item.media.alt ?? ''"> 
                <img class="img-fluid mb-25px d-md-none" :src="item.media.image_full_mb" :alt="item.media.alt ?? ''">
                <h3 v-if="item.title && item.title.trim()">{{ item.title }}</h3>
                <div v-if="item.description" class="gray mb-25px" style="text-align:center" v-html="item.description"></div>
            </a>
            <template v-if="item.link_type == 'button' || item.link_type == 'none'">
                <img class="img-fluid mb-25px d-none d-md-block" :src="item.media.image_full" :alt="item.media.alt ?? ''"> 
                <img class="img-fluid mb-25px d-md-none" :src="item.media.image_full_mb" :alt="item.media.alt ?? ''">
                <h3 v-if="item.title && item.title.trim()">{{ item.title }}</h3>
                <div v-if="item.description" class="gray mb-25px" style="text-align:center" v-html="item.description"></div>
                <a v-if="item.button_link.title && item.link_type !== 'none'" class="btn-outline-dark btn" :href="getLangUrl(item.button_link.url, baseUrl, locale)" :target="item.button_link.target">{{ item.button_link.title }}<span class="css-arrow css-arrow-right" ></span></a>
            </template>
        </div>
    </div>    
</template>
<script lang="ts" setup>
    import { ref } from 'vue';
    const props = defineProps(["data"]);
    const double = computed(() => props.data);
    const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl } from '~/utils/getLangUrl';

</script>
